export interface SalesOrderVatAnalysis {
  header: string;
  nettValue: number;
  taxRate: number;
  vat: number;
  overallValue: number;
  currencySymbol: string;
}
